module.exports = __webpack_public_path__ + "static/media/project4.cee7622d.jpg";